import  SettingsMesssage from './SettingsMessage'

export default  SettingsMesssage